import { JOB_NAME } from "../../../constants/jobs";
import { SOURCE_LANG_SHORT } from "../constants";

export const mapLanguagesToOptions = (languages) =>
  languages.map((language) => ({ label: language.name, value: language }));

export const hasIncompleteVoice = (voices) =>
  voices.some((voice) => !voice.languageCode || !voice.name);

export const buildCreateLanguagePayload = (payload) => ({
  name: payload.name,
  shortName: payload.shortName,
  isLangTo: payload.isLangTo,
  voices: payload.voices,
});

export const buildDuplicateLessonsJob = (toLangShort) => ({
  job_name: JOB_NAME.DUPLICATE_LESSONS,
  arguments_passed: JSON.stringify({
    fromLangShort: SOURCE_LANG_SHORT,
    toLangShort,
  }),
});

export const buildImportDatabaseJob = (payload) => ({
  job_name: JOB_NAME.IMPORT_DATABASE,
  arguments_passed: JSON.stringify({
    sourceLangShort: SOURCE_LANG_SHORT,
    langShort: payload.langShort,
    csvDelimiter: payload.csvDelimiter || ",",
  }),
  file_base64: payload.fileBase64,
});

export const buildMarkWordsAsUserJob = (languageShort) => ({
  job_name: JOB_NAME.MARK_WORDS_AS_USER,
  arguments_passed: JSON.stringify({
    languageShort,
  }),
});

export const getJobErrorMessage = (error) =>
  error?.response?.data?.message || "Something went wrong";
